import { useLangContext } from "context/Lang";
import { ToastMessage } from "primereact/toast";
import { ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";
import { setUser } from "storeRedux/slices/authSlice";
import { setToast } from "storeRedux/slices/toast";
import { RootStateType } from "storeRedux/store";


export const Logout = (): ReactElement => {


    const dispatch = useDispatch();
    const auth = useSelector((state: RootStateType) => state.auth);
    const { user } = auth;
    const { gW } = useLangContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            dispatch(setUser({}));

            dispatch(setToast({ severity: "success", detail: gW("[1]-is-success", { 1: "logout" }) } as ToastMessage))

            navigate(routes.auth);
        } else {
            navigate(routes.auth);
        }
    }, []);

    return <></>
}